/* eslint-disable */
define(['underscore'], function (_) {
  // TODO [rajeshkr]: Clean up this file after we fix the xml2json to output only the required object properties and not the whole metadata
    function model(settings) {
        if (!_.isObject(settings) || !_.isObject(settings.data)) {
            throw 'Localization config was not an Object';
        }

        this.data = settings.data;
        this.lcid = settings.lcid;
    }

    // get the config item (object) under path, filtered by attr(optional)
    // will return undefined when there is no result for the path or
    model.prototype.getConfig = function (path, attrname, attrvalue) {
        var ret = _.extend({}, this.data);
        if (_.isUndefined(path) || _.isNull(path)) {
            ret;
        }
        var paths = path.split('/');
        // first locate the config object
        for (var i = 0; i < paths.length; i++)
        {
            ret = ret[paths[i]];
            if (_.isUndefined(ret))
            {
                return ret;
            }
        }

        // then filter the results by attr if attrname is not null
        if ((!_.isUndefined(attrname)) && (!_.isNull(attrname)) && (!_.isUndefined(attrvalue)) && (!_.isNull(attrvalue)))
        {
            if (!_.isUndefined(ret)) {
                return _.find(ret, function (item) { return _.isObject(item.$) && item.$[attrname] == attrvalue; });
            }
        }
        return ret;
    }

    // get the attribute of path, path in the format of father/son
    // in xml, it is like <PhoneSupport scenario="RegularSignup">
    // attribute in js is like this  "$": { "scenario": "YahooMigration"},
    // will return array contains the objects
    model.prototype.GetAttrs = function (path) {
        var ret = this.getConfig(path);
        if (!_.isUndefined(ret) ) {
            var allAttr = _.isArray(ret) ? _.map(ret, function (item) { return item['$'] }) : [ret['$']];
            return _.filter(allAttr, function (value) { return !_.isUndefined(value) });
        }

        return ret;
    }

    model.prototype.getFirstOrDefaultValueFromConfigItem = function (item, name) {
        return _.isObject(item) && _.isArray(item[name]) ? item[name][0] :
             _.isObject(item) && !_.isUndefined(item[name]) ? item[name] :
            '';
    }

    return model;
});
